import { isUserLogged } from "services/functions";
import { Languages } from "types/LanguagesI";
import { loggedUserPages, PageI, PageType, PopUpType } from "../../types/PageI"

const PageReducer = (state: PageI, action: any) => {

    const { payload, type } = action
    switch (type) {
        case ("header_loaded"): {
            return {
                ...state, 
                header_loaded: true
            }
        }
        case ("add_notification"): {
            let message = payload.notification.message
                    
            let new_notification = {
                id: Date.now(),
                type: payload.notification.type,
                message: message
            }

            
            let exist = state.notifications.filter((item: any, index) => {
                if (item.message == message) {
                    return true
                }   
            })
            
            if (exist.length > 0) {
                return {
                    ...state
                }
            }
            let notifications = [...state.notifications.slice(-4), new_notification]

            return {
                ...state, 
                notifications: notifications
            }
        }
        case ("remove_all_notification"): {
            return {
                ...state, 
                notifications: []
            }
        }
        case ("remove_notification"): {
            // console.log("remove_notification");
            // console.log(payload);
            
            // let id = payload.notification_id
            
            let index = state.notifications.findIndex(n => n['id']=== payload.notification_id)
            // console.log(index);
            let before = state.notifications.slice(0, index)
            let after = state.notifications.slice(index + 1)
            let notifications = [...before, ...after]
            
            return {
                ...state, 
                notifications: notifications
            }
        }
        case ("set_popup"): {
            // console.log("set_popup");
            

            let popup = payload.popup as PopUpType
            let props = (popup === null) ? {} :payload.props
            // console.log(popup);
            // console.log(props);
            

            
            return {
                ...state,
                popup: popup,
                props: props
            }
        }
        case ("log_out") : {
            let page =  PageType.entrance
            // sessionStorage.removeItem('xf_active_page');
            sessionStorage.setItem('xf_active_page', JSON.stringify(page));
            
            let id = Date.now().toString();
            
            let url_search_params = new URLSearchParams(window.location.search) 
            url_search_params.set('xf_page', page)
            window.history.pushState(
                {
                    "id": id,
                    "xf_page": page
                }, 
                '', 
                "?" + url_search_params.toString()
            );
            return {
                ...state, 
                type: page,
                notifications: []
            }
        }
        case ("render"): {
            // console.log("render".toUpperCase());
            
            let page = payload.page as PageType
            let props = payload.props 
            let popstate = payload.popstate || false
            
            // console.log("state page".toUpperCase(),state.type);
            
            // console.log("page".toUpperCase(), page);
            // console.log("is pop state:".toUpperCase(), popstate);
            
            
            sessionStorage.setItem('xf_active_page', JSON.stringify(page));
            
            if (state.type !== page && !popstate) {
                let url_search_params = new URLSearchParams(window.location.search) 
                url_search_params.set('xf_page', page)
                let id = Date.now().toString();

                window.history.pushState(
                    {
                        "id": id,
                        "xf_page": page
                    }, 
                    '', 
                    "?" + url_search_params.toString()
                );
            }

            
            if (loggedUserPages.includes(page) && !isUserLogged()) {
                page = PageType.entrance
                let id = Date.now().toString()
                
                let url_search_params = new URLSearchParams(window.location.search) 
                url_search_params.set('xf_page', page)

                window.history.pushState(
                    {
                        "id": id,
                        "xf_page": page
                    },
                    '',
                    "?" + url_search_params.toString()
                )
            }


            return {        
                ...state,                
                type: page,
                props: props,
                notifications: []
            }
        }

        default:
            return state 
    }
}

export default PageReducer